/**
 * @module sagas/SmartConversion.js
 *
 * This file replaces our ActionRouter and currently calls our Promised based
 * middleware workflow functions. Eventually, all Workflows and ActionCreators
 * should themselves be Sagas.
 */
import { all, take } from 'redux-saga/effects';

import {
  onUpsellAction,
  onUpsellEngagement,
} from '../actions/workflows/SmartConversion/SmartConversion';
import { actions } from '../constants/SmartConversion';
import { tryCall } from '../sagas/Helpers';
import { getStore } from '../store/StoreAccessor';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

/**
 * Watch for TRIGGER_SMART_CONVERSION_UPSELL action and execute blocking onUpsellAction workflow
 */
export function* watchUpsellAction() {
  while (LOOP) {
    const action = yield take(actions.TRIGGER_SMART_CONVERSION_UPSELL);
    yield tryCall(onUpsellAction, action, getStore());
  }
}

/**
 * Watch for LAUNCH_SMART_CONVERSION_PRODUCT action and execute blocking onUpsellEngagement workflow
 */
export function* watchUpsellEngagement() {
  while (LOOP) {
    const action = yield take(actions.LAUNCH_SMART_CONVERSION_PRODUCT);
    yield tryCall(onUpsellEngagement, action, getStore());
  }
}

/**
 * Root SmartConversion Saga
 */
export default function* smartConversionSaga() {
  yield all([spawn(watchUpsellAction), spawn(watchUpsellEngagement)]);
}
